import {chatDiconnectedPopup, removeDisconnectPopup} from './chat-warning';

export function listenOnline() {
  window.addEventListener('online', function(e) {
    removeDisconnectPopup();
  });
  window.addEventListener('offline', function(e) {
    chatDiconnectedPopup();
  });
}



//////////////////
// WEBPACK FOOTER
// ./src/ui/js/internet-loss-warn.js
// module id = 1549
// module chunks = 8